import AmpLocale from './amp-locale-core';
var ampLocale = new AmpLocale();
export default ampLocale;